var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveInativeEmptyAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 399,
    viewBox: "0 0 460 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7728_418423)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 460,
    height: 329,
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 460,
    height: 329,
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.658 151.928C395.658 165.141 388.941 180.766 376.697 196.803C364.461 212.828 346.741 229.215 324.828 243.942C281.001 273.396 220.451 296.177 153.575 296.177C86.6941 296.177 48.4794 275.772 26.9544 245.507C5.40299 215.205 0.5 174.911 0.5 134.959C0.5 95.0199 7.40628 70.9091 30.8192 56.6874C42.5611 49.555 58.4964 44.8821 79.8964 41.9965C101.293 39.1113 128.113 38.0176 161.6 38.0176C228.516 38.0176 287.075 53.2355 328.888 75.1119C349.795 86.0505 366.5 98.6453 377.971 111.819C389.445 124.995 395.658 138.719 395.658 151.928Z",
    stroke: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.186 204.884C348.186 216.19 342.423 229.573 331.904 243.318C321.392 257.052 306.168 271.098 287.339 283.722C249.68 308.971 197.65 328.5 140.185 328.5C82.7149 328.5 49.8944 311.009 31.4109 285.082C12.9011 259.118 8.68652 224.588 8.68652 190.334C8.68652 156.092 14.6223 135.453 34.7117 123.28C44.7922 117.171 58.4778 113.166 76.8671 110.692C95.2528 108.219 118.301 107.281 147.083 107.281C204.587 107.281 254.907 120.328 290.835 139.08C308.799 148.457 323.149 159.251 333.002 170.539C342.857 181.829 348.186 193.58 348.186 204.884Z",
    stroke: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.501 127.406C459.501 139.533 452.029 155.644 438.378 173.038C424.743 190.411 405 208.989 380.59 226.04C331.768 260.142 264.329 288.096 189.852 288.096C115.359 288.096 72.7811 265.369 48.7962 231.647C24.7849 197.887 19.3251 153.002 19.3251 108.51C19.3251 64.0302 27.0162 37.1524 53.1169 21.2987C66.2028 13.3503 83.9578 8.14518 107.793 4.93135C131.625 1.71798 161.496 0.5 198.789 0.5C273.304 0.5 338.524 20.031 385.103 45.6923C408.394 58.5234 427.01 72.8794 439.796 87.0787C452.593 101.29 459.501 115.287 459.501 127.406Z",
    stroke: "#FAFAFA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7728_418423)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 45.5,
    width: 300,
    height: 320,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 61.5,
    width: 166,
    height: 15,
    rx: 7.5,
    fill: "#E9F4FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 329.5,
    width: 166,
    height: 15,
    rx: 7.5,
    fill: "#E9F4FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 85.5,
    width: 78,
    height: 15,
    rx: 7.5,
    fill: "#E9F4FE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_7728_418423)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 176.5,
    width: 125,
    height: 15,
    rx: 7.5,
    fill: "#DCEEFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_7728_418423)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 238.5,
    width: 78,
    height: 15,
    rx: 7.5,
    fill: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_7728_418423)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-12-outside-1_7728_418423",
    maskUnits: "userSpaceOnUse",
    x: 102.369,
    y: 163.89,
    width: 150,
    height: 131,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 102.369,
    y: 163.89,
    width: 150,
    height: 131
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.802 286.248C115.485 276.015 109.374 263.274 107.226 249.603C105.078 235.931 106.988 221.93 112.719 209.333C118.449 196.737 127.749 186.098 139.467 178.734C151.184 171.37 164.804 167.606 178.64 167.906C192.476 168.207 205.92 172.559 217.306 180.425C228.693 188.291 237.522 199.323 242.701 212.157C247.879 224.991 249.179 239.062 246.439 252.627C243.7 266.192 237.041 278.656 227.288 288.474L225.281 286.48C234.644 277.055 241.036 265.09 243.666 252.067C246.296 239.044 245.048 225.536 240.077 213.216C235.106 200.895 226.629 190.304 215.698 182.753C204.767 175.202 191.861 171.024 178.579 170.735C165.296 170.447 152.221 174.061 140.972 181.13C129.724 188.199 120.795 198.412 115.294 210.505C109.792 222.598 107.959 236.039 110.021 249.164C112.083 262.288 117.949 274.52 126.894 284.343L124.802 286.248Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.802 286.248C115.485 276.015 109.374 263.274 107.226 249.603C105.078 235.931 106.988 221.93 112.719 209.333C118.449 196.737 127.749 186.098 139.467 178.734C151.184 171.37 164.804 167.606 178.64 167.906C192.476 168.207 205.92 172.559 217.306 180.425C228.693 188.291 237.522 199.323 242.701 212.157C247.879 224.991 249.179 239.062 246.439 252.627C243.7 266.192 237.041 278.656 227.288 288.474L225.281 286.48C234.644 277.055 241.036 265.09 243.666 252.067C246.296 239.044 245.048 225.536 240.077 213.216C235.106 200.895 226.629 190.304 215.698 182.753C204.767 175.202 191.861 171.024 178.579 170.735C165.296 170.447 152.221 174.061 140.972 181.13C129.724 188.199 120.795 198.412 115.294 210.505C109.792 222.598 107.959 236.039 110.021 249.164C112.083 262.288 117.949 274.52 126.894 284.343L124.802 286.248Z",
    fill: "#E9F4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.802 286.248C115.485 276.015 109.374 263.274 107.226 249.603C105.078 235.931 106.988 221.93 112.719 209.333C118.449 196.737 127.749 186.098 139.467 178.734C151.184 171.37 164.804 167.606 178.64 167.906C192.476 168.207 205.92 172.559 217.306 180.425C228.693 188.291 237.522 199.323 242.701 212.157C247.879 224.991 249.179 239.062 246.439 252.627C243.7 266.192 237.041 278.656 227.288 288.474L225.281 286.48C234.644 277.055 241.036 265.09 243.666 252.067C246.296 239.044 245.048 225.536 240.077 213.216C235.106 200.895 226.629 190.304 215.698 182.753C204.767 175.202 191.861 171.024 178.579 170.735C165.296 170.447 152.221 174.061 140.972 181.13C129.724 188.199 120.795 198.412 115.294 210.505C109.792 222.598 107.959 236.039 110.021 249.164C112.083 262.288 117.949 274.52 126.894 284.343L124.802 286.248Z",
    stroke: "#E9F4FE",
    strokeWidth: 8,
    mask: "url(#path-12-outside-1_7728_418423)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.09 295.896C109.609 284.664 101.769 270.24 98.5877 254.497C95.4061 238.753 97.0294 222.417 103.247 207.608C109.465 192.798 119.99 180.199 133.456 171.446C146.923 162.692 162.709 158.188 178.767 158.517C194.826 158.846 210.414 163.994 223.511 173.292C236.607 182.591 246.607 195.611 252.212 210.662C257.817 225.714 258.769 242.103 254.945 257.703C251.121 273.303 242.696 287.393 230.765 298.145L228.619 295.765C240.073 285.442 248.161 271.915 251.832 256.94C255.504 241.964 254.589 226.231 249.208 211.781C243.827 197.331 234.228 184.832 221.655 175.906C209.083 166.979 194.118 162.037 178.702 161.721C163.286 161.405 148.131 165.729 135.203 174.133C122.275 182.536 112.171 194.631 106.202 208.848C100.233 223.065 98.6749 238.748 101.729 253.862C104.784 268.975 112.31 282.822 123.331 293.605L121.09 295.896Z",
    fill: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.5 215C138.57 215 137 216.57 137 218.5C137 220.43 138.57 222 140.5 222C142.43 222 144 220.43 144 218.5C144 216.57 142.43 215 140.5 215ZM140.5 220C139.67 220 139 219.33 139 218.5C139 217.67 139.67 217 140.5 217C141.33 217 142 217.67 142 218.5C142 219.33 141.33 220 140.5 220ZM149.5 224C147.57 224 146 225.57 146 227.5C146 229.43 147.57 231 149.5 231C151.43 231 153 229.43 153 227.5C153 225.57 151.43 224 149.5 224ZM149.5 229C148.67 229 148 228.33 148 227.5C148 226.67 148.67 226 149.5 226C150.33 226 151 226.67 151 227.5C151 228.33 150.33 229 149.5 229ZM138.41 231L137 229.59L151.59 215L153 216.41L138.41 231Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 211.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dd_7728_418423)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 241,
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.52 255.533C174.493 254.747 173.52 253.933 173.52 252.667C173.52 251.213 174.867 250.2 177.12 250.2C179.493 250.2 180.373 251.333 180.453 253H183.4C183.307 250.707 181.907 248.6 179.12 247.92V245H175.12V247.88C172.533 248.44 170.453 250.12 170.453 252.693C170.453 255.773 173 257.307 176.72 258.2C180.053 259 180.72 260.173 180.72 261.413C180.72 262.333 180.067 263.8 177.12 263.8C174.373 263.8 173.293 262.573 173.147 261H170.213C170.373 263.92 172.56 265.56 175.12 266.107V269H179.12V266.133C181.72 265.64 183.787 264.133 183.787 261.4C183.787 257.613 180.547 256.32 177.52 255.533Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.5,
    y: 241.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter5_dd_7728_418423)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 201,
    width: 28,
    height: 28,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.193 221.965C213.707 221.148 214.01 220.203 214.01 219.177C214.01 216.272 211.665 213.927 208.76 213.927C205.855 213.927 203.51 216.272 203.51 219.177C203.51 222.082 205.855 224.427 208.748 224.427C209.775 224.427 210.732 224.123 211.537 223.61L215.177 227.25L216.833 225.593L213.193 221.965ZM208.76 222.093C207.15 222.093 205.843 220.787 205.843 219.177C205.843 217.567 207.15 216.26 208.76 216.26C210.37 216.26 211.677 217.567 211.677 219.177C211.677 220.787 210.37 222.093 208.76 222.093ZM208.34 212.177C207.477 212.2 206.648 212.387 205.89 212.702L205.248 211.733L200.815 218.943L197.303 214.837L193.068 221.615L191.167 220.25L197 210.917L200.5 215L205.167 207.417L208.34 212.177ZM211.362 212.76C210.615 212.433 209.81 212.235 208.97 212.188L214.943 202.75L216.833 204.127L211.362 212.76Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.5,
    y: 201.5,
    width: 27,
    height: 27,
    rx: 3.5,
    stroke: "#D9D9D9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7728_418423",
    x: 72,
    y: 45.5,
    width: 335,
    height: 353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7728_418423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_7728_418423",
    x: 262,
    y: 174.5,
    width: 149,
    height: 39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_7728_418423",
    result: "effect2_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_7728_418423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_7728_418423",
    x: 271,
    y: 236.5,
    width: 84,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_7728_418423",
    result: "effect2_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_7728_418423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_7728_418423",
    x: 77,
    y: 158.5,
    width: 200.25,
    height: 179.646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7728_418423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dd_7728_418423",
    x: 141,
    y: 241,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_7728_418423",
    result: "effect2_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_7728_418423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dd_7728_418423",
    x: 155,
    y: 186,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_7728_418423",
    result: "effect2_dropShadow_7728_418423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_7728_418423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7728_418423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 460,
    height: 329,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveInativeEmptyAccounts);
export default __webpack_public_path__ + "static/media/active_inative_empty_accounts.013c1eb50ecbc60b87174bec02ba134a.svg";
export { ForwardRef as ReactComponent };